/* tslint:disable */
/* eslint-disable */
import { config } from './config';

// typing hacks for intercom code below
declare global {
  interface Window {
    attachEvent: any;
    intercomSettings: any;
    Intercom: any;
  }
}

function boot({ email, name, userId, userHash }: { email?: string; name?: string; userId?: string; userHash?: string | null }) {
  if (window.Intercom) {
    window.Intercom('boot', {
      app_id: config.appId,
      created_at: Date.now(),
      email,
      name,
      user_id: userId,
      user_hash: userHash,
      hide_default_launcher: true,
    });
  }
}

function close() {
  if (window.Intercom) {
    window.Intercom('shutdown');
  }
}

function hide() {
  if (window.Intercom) {
    window.Intercom('hide');
  }
}

function show() {
  if (window.Intercom) {
    window.Intercom('show');
  }
}

function update(userDetails: Record<string, any>) {
  if (window.Intercom) {
    window.Intercom('update', userDetails);
  }
}

function trackEvent<
  E extends
    | 'add_bank_account'
    | 'auto_invest'
    | 'create_bd_account'
    | 'invest'
    | 'investor_account_deactivated'
    | 'referral_program_joined'
    | 'request_manual_accreditation'
    | 'view_signup_1'
    | 'viewed_messenger'
    | 'viewed_messenger'
    | 'withdraw',
>(
  event: E,
  metadata?: E extends 'viewed_messenger'
    ? { extra: string }
    : E extends 'auto_invest'
    ? { amount: string }
    : E extends 'add_bank_account'
    ? { method: 'plaid' }
    : E extends 'withdraw'
    ? { amount: string; withdrawal_type: 'Full Withdrawal' | 'Partial Withdrawal' }
    : any,
) {
  if (window.Intercom) {
    window.Intercom('trackEvent', event, metadata);
  }
}

let hasInitialized = false;

export default (() => {
  if (!hasInitialized) {
    //Set your APP_ID
    var APP_ID = config.appId;
    // ignore ts typings
    // Snippet: https://developers.intercom.com/installing-intercom/docs/basic-javascript
    // @ts-ignore
    (function () {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function () {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/' + APP_ID;
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })();

    hasInitialized = true;
  }

  return {
    boot,
    client: window.Intercom,
    close,
    hide,
    show,
    trackEvent,
    update,
  };
})();
